import type {
  LocationsTableColumn,
  LocationsTableProps,
} from "./locations-list-table.type";

import { Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";

import TableTitleCell from "@/components/Elements/TableTitleCell";
import ListTable from "@/modules/list-table";
import LocationBreadcrumb from "@/modules/location/location-breadcrumb";
import { ModelLink } from "@/modules/model-link";
import {
  getTableFilterQueryable,
  TABLE_FILTER_TEXT,
} from "@/modules/table-filter";
import { format, fromNow } from "@/utilities/date";

import LocationsListTableRowActions from "./locations-list-table-row-actions";

const LocationsListTable = ({
  isSectorsTable,
  ...listTableProps
}: LocationsTableProps) => {
  const { t } = useTranslation();

  const columns: LocationsTableColumn[] = [
    {
      title: t("global:name"),
      dataIndex: "name",
      render: (_, location) => (
        <TableTitleCell tooltip={location.name}>
          <ModelLink model="location" item={location} />
        </TableTitleCell>
      ),
      sorter: true,
      fixed: "left",
      minWidth: 220,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("organization:form.description.label"),
      dataIndex: "description",
      render: (_, { description }) => (
        <Typography.Text>{description}</Typography.Text>
      ),
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("global:hierarchy"),
      dataIndex: "location_id",
      render: (_, location) => (
        <LocationBreadcrumb
          location={location}
          include={["location"]}
          hideIcon
          ellipsis
          compact
        />
      ),
      ...getTableFilterQueryable({ model: "locations", withContext: true }),
    },
    {
      title: t("global:assetPlural"),
      dataIndex: "assets_count",
      sorter: true,
    },
    {
      title: t("global:lastUpdate"),
      dataIndex: "updated_at",
      sorter: true,
      render: (_, { updated_at }) => (
        <Tooltip title={format(updated_at, "LLLL")}>
          {fromNow(updated_at)}
        </Tooltip>
      ),
    },
    {
      title: "",
      fixed: "right",
      render: (_, location) => (
        <LocationsListTableRowActions
          location={location}
          isSectorsTable={isSectorsTable}
        />
      ),
    },
  ];

  return (
    <ListTable
      modelKey="location"
      columns={columns}
      showExportButton={!isSectorsTable}
      {...listTableProps}
    />
  );
};

export default LocationsListTable;
